<template>
  <div class="ui">
      <div class="navbar-wrapper">
        <div class="navbar">
          <div class="left">
          </div>
          <div class="title">PACO-UI</div>
          <div class="right"></div>
        </div>
      </div>
    <Tabs type="normal" act='1'>
      <Tab title="tabname1" >
        hello word
      </Tab>
      <Tab title="tabname2" >
        hello andrond
        <input type="text" name="">
      </Tab>
      <Tab title="tabname3" >
        hello ios
      </Tab>
    </Tabs>

  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods:{

  },
  events:{
    'tba-msg'(msg){
      console.log(msg)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TabView.vue?1e23f74c